var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full bg-gray-light"},[_c('div',{staticClass:"lg:max-w-5xl my-4 px-2 sm:px-6"},[_c('Breadcrumbs',{staticClass:"mb-8",attrs:{"crumbs":_vm.crumbs}}),_c('SystemInfo',{attrs:{"helpLink":'https://ajuda.sie.sc.gov.br/bc/organizacao/',"alerts":_vm.alerts}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }